import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
export const ProgressOverlay = ({ open }) => {
    return (React.createElement(Backdrop, { open: open, sx: { zIndex: 10000 } },
        React.createElement(CircularProgress, { color: "inherit" })));
};
